export interface PlayerGameResult {
  gameId: string;
  net: number;
}

export interface PlayerPointsResult {
  perGame: Record<string, number>;
  total: number;
  currentWinStreak: number;
}

/** Pure: computes points for one player's results, already in game order. */
export const computePlayerPoints = (results: PlayerGameResult[]): PlayerPointsResult => {
  const perGame: Record<string, number> = {};
  let total = 0;
  let streak = 0;
  for (const { gameId, net } of results) {
    const rounded = Math.round(net * 100) / 100;
    let pts = 0;
    if (rounded > 0) {
      streak += 1;
      pts = streak >= 3 ? 10 : 5;
    } else if (rounded < 0) {
      streak = 0;
      pts = -5;
    }
    perGame[gameId] = pts;
    total += pts;
  }
  return { perGame, total, currentWinStreak: streak };
};
